import { Component } from '@angular/core';

@Component({
  selector: 'app-sign-out-thin',
  templateUrl: './sign-out-thin.component.html',
  styleUrls: ['./sign-out-thin.component.scss']
})
export class SignOutThinComponent {

}
